<section class="hipaa-section" aria-labelledby="hipaa-title">
    <div class="hippa-header">
        <h2 id="hipaa-title">{{ 'HIPAA_Title' | translate }}</h2>
        <p class="hipaa-subtitle">{{ 'HIPAA_Subtitle' | translate }}</p>

    </div>
    <div class="hipaa-container">
        <ul class="hipaa-highlights" role="list">
            <li class="publish-point"><span class="icon-check" aria-hidden="true"></span>
                <span>{{'HIPAA_Detail_SecureRecords_Title' | translate }}</span>
            </li>
            <li class="publish-point">
                <span class="icon-check" aria-hidden="true"></span>
                <span>
                    {{'HIPAA_Detail_Encryption_Title' | translate }}
                </span>
            </li>
            <li class="publish-point">
                <span class="icon-check" aria-hidden="true"></span>
                <span>{{'HIPAA_Detail_BAA_Title' | translate }}

                </span>
            </li>
            <li class="publish-point">
                <span class="icon-check" aria-hidden="true"></span>
                <span>{{'HIPAA_Detail_Confidentiality_Title' | translate }}</span>
            </li>
            <li class="publish-point">
                <span class="icon-check" aria-hidden="true"></span>
                <span>{{'HIPAA_Detail_Trust_Title' | translate }}</span>
            </li>
        </ul>
                <ul class="hipaa-highlights" role="list">
            <li class="publish-point">
                <span class="icon-check" aria-hidden="true"></span>
                <span>{{'HIPAA_Point_PrivacyProtected' | translate }}</span>
            </li>
            <li class="publish-point">
                <span class="icon-check" aria-hidden="true"></span>
                <span>
                    {{'HIPAA_Point_CompliantSecurity' | translate }}
                </span>
            </li>
            <li class="publish-point">
                <span class="icon-check" aria-hidden="true"></span>
                <span>{{'HIPAA_Point_EncryptedSafety' | translate }}

                </span>
            </li>
            <li class="publish-point">
                <span class="icon-check" aria-hidden="true"></span>
                <span>{{'HIPAA_Point_GuardHealthData' | translate }}</span>
            </li>
        </ul>
        <div class="support-image">
            <img src="/assets/images/hippa.webp" [alt]="'HIPAA_Title' | translate" width="488" height="304" >
        </div>

    </div>
</section>